module.exports = __webpack_public_path__ + "static/media/donate_success.423fe413.png";